<template lang="pug">
	div.flex.min-h-screen.justify-center
		
		.w-full.max-w-xl.mt-32.flex.flex-col.items-stretch
			a.flex.items-center.-ml-1(@click="goBack")
				eva-icon.icon(name="chevron-left")
				span Go back
			
			.flex.-mx-1.my-4(v-if="pendingUpdates.length > 1")
				.h-2.rounded-full.bg-gray-1.mx-1.w-full(v-for="(pu, index) in pendingUpdates" :class="{active: index <= currentIndex}")
			
			transition-group(name="slideThru")
				form(v-if="index == currentIndex" :key="pu.id" @submit.prevent="makeUpdate" v-for="(pu, index) in pendingUpdates")
					h1.text-3xl.mt-4 Update your goal:
					h2.text-3xl.text-gray-6 {{pu.title}}

					.border-t.my-4

					label Target
					.flex.items-center
						input.w-32(v-model="pu.initialValue" @click="select")
						p.flex-shrink-0.ml-2 of {{pu.targetValue}} {{pu.unit}}
					
					.border-t.my-4

					label Status
					.flex.p-1.w-full.rounded.bg-gray-1.text-gray-6.uppercase.text-center.text-xs.tracking-wide.cursor-pointer.max-w-sm
						.rounded.p-1.flex-grow(class="hover:bg-gray-3" :class="{blue: pu.status == 'On track'}" @click="pu.status = 'On track'") On track
						.rounded.p-1.flex-grow(class="hover:bg-gray-3" :class="{orange: pu.status == 'At risk'}" @click="pu.status = 'At risk'") At risk
						.rounded.p-1.flex-grow(class="hover:bg-gray-3" :class="{red: pu.status == 'Off track'}" @click="pu.status = 'Off track'") Off track

					.border-t.my-4

					label Comment
						span.text-xs.text-gray-5.ml-2 Optional
					textarea.h-32.pt-2(v-model="comment" placeholder="Give your teammates some context...")

					button.main.mt-4.self-start.px-16(type="submit")
						span(v-if="index == pendingUpdates.length - 1") Finish
						span(v-else) Continue

			Loader(v-if="loading" info="Posting update...")
</template>

<script>
import Loader from "../components/Loader";
import { auth, firestore } from "../firebase.config";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Update",
  components: { Loader },
  data() {
    return {
      pendingUpdates: [],
      redirect: "",
      comment: "",
      loading: false,
      currentIndex: 0
    };
  },
  computed: {
    ...mapGetters(["company", "keyResults", "profile"]),
    current() {
      return this.pendingUpdates[this.currentIndex];
    }
  },
  created() {
    this.setup();
  },
  methods: {
    ...mapActions(["select"]),
    setup() {
      var id = this.$route.query.kr;

      if (id) {
        this.pendingUpdates.push(this.keyResults.find(kr => kr.id == id));
        this.redirect = "/key-result?kr=" + this.pendingUpdates[0].id;
        this.pendingUpdates[0].done = false;
      } else if (auth.currentUser.uid) {
        this.keyResults.forEach(kr => {
          if (this.isOwner(kr)) this.pendingUpdates.push(kr);
          this.redirect = "/";
        });
        this.pendingUpdates.forEach(pu => {
          pu.done = false;
        });
      } else {
        this.$router.push("/");
      }
    },
    isOwner(kr) {
      return kr.owners.some(owner => owner == auth.currentUser.uid);
    },
    goBack() {
      this.currentIndex == 0
        ? this.$router.push(this.redirect)
        : this.currentIndex--;
    },
    makeUpdate() {
      const isLast = this.currentIndex == this.pendingUpdates.length - 1;

      if (isLast) this.loading = true;
      else this.currentIndex++;

      if (!this.current.initialValue.length) this.current.initialValue = 0;

      Promise.all([
        this.$store.dispatch("updateDoc", {
          collection: "keyResults",
          id: this.current.id,
          item: {
            initialValue: this.current.initialValue,
            status: this.current.status
          }
        }),
        this.$store.dispatch("createDoc", {
          collection: "updates",
          item: {
            value: this.current.initialValue,
            comment: this.comment,
            status: this.current.status,
            unit: this.current.unit,
            author: auth.currentUser.uid,
            date: firestore.FieldValue.serverTimestamp(),
            companyId: this.profile.companyId,
            kr: this.current.id
          }
        })
      ])
        .then(() => {
          this.loading = false;
          this.$store.dispatch("fireNotification", {
            title: "Posted your update!",
            type: "success"
          });
          this.$store.dispatch("getUpdates", this.profile.companyId);
          this.$store.dispatch("getKeyResults", this.profile.companyId);
          if (isLast) {
            heap.track("postUpdate");
            heap.track("postUpdates");
            this.$router.push(this.redirect);
          } else heap.track("postUpdate");
        })
        .catch(() => {
          this.loading = false;
          this.$store.dispatch("fireNotification", {
            title: "Couldn't post update",
            message: "Please check your wifi and try again",
            type: "error",
            icon: "wifi-off"
          });
        });
    }
  }
};
</script>

<style lang="sass" scoped>
.active
  @apply bg-gray-5
</style>
